import React, { useState } from 'react';
import { LogIn } from 'lucide-react';
import { api } from '../../lib/api.js';
import { Field, Text } from './fields.jsx';
import { ErrorNotice } from '../../components/states.jsx';

export default function AdminLogin({ onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const user = await api.auth.login(username, password);
      onSuccess(user.username);
    } catch (loginError) {
      setError(loginError.message);
      setPassword('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <h1>Přihlášení do správy</h1>
        <p>Odsud se upravuje obsah webu semináře.</p>

        {error && <div style={{ marginBottom: '1rem' }}><ErrorNotice>{error}</ErrorNotice></div>}

        <Field label="Jméno" id="jmeno">
          <Text
            id="jmeno"
            value={username}
            onChange={setUsername}
            autoComplete="username"
            autoCapitalize="none"
            autoFocus
            required
          />
        </Field>

        <Field label="Heslo" id="heslo">
          <input
            id="heslo"
            className="input"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />
        </Field>

        <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={busy}>
          <LogIn size={16} /> {busy ? 'Přihlašuji…' : 'Přihlásit'}
        </button>
      </form>
    </div>
  );
}
